import { useState } from 'react';
import {
	AuthFieldIcon,
	AuthPasswordInput,
	AuthPasswordToggle,
	AuthPasswordWrap,
} from './authModal.styles';

const IconLock = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<rect
			x="5"
			y="10"
			width="14"
			height="10"
			rx="2.2"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<path
			d="M8.2 10V7.8a3.8 3.8 0 0 1 7.6 0V10"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
);

const EyeIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M2.25 12C3.75 7.5 7.5 4.5 12 4.5C16.5 4.5 20.25 7.5 21.75 12C20.25 16.5 16.5 19.5 12 19.5C7.5 19.5 3.75 16.5 2.25 12Z"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinejoin="round"
		/>
		<circle cx="12" cy="12" r="3.25" stroke="currentColor" strokeWidth="1.75" />
	</svg>
);

const EyeSlashIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M3 3L21 21"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
		/>
		<path
			d="M9.9 9.9C9.35 10.45 9 11.2 9 12C9 13.65 10.35 15 12 15C12.8 15 13.55 14.65 14.1 14.1M6.6 6.6C4.85 7.95 3.45 9.85 2.25 12C3.75 16.5 7.5 19.5 12 19.5C14.05 19.5 15.95 18.8 17.55 17.55M10.05 5.2C10.65 5.1 11.3 5 12 5C16.5 5 20.25 8 21.75 12.5C21.2 13.85 20.4 15.05 19.4 16"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const PasswordInput = ({
	id,
	value,
	onChange,
	placeholder,
	disabled = false,
	autoFocus = false,
	minLength,
	showPasswordLabel = 'Show password',
	hidePasswordLabel = 'Hide password',
	autoComplete,
}) => {
	const [isVisible, setIsVisible] = useState(false);

	const toggleVisibility = () => {
		setIsVisible((prev) => !prev);
	};

	return (
		<AuthPasswordWrap>
			<AuthFieldIcon>
				<IconLock />
			</AuthFieldIcon>
			<AuthPasswordInput
				id={id}
				type={isVisible ? 'text' : 'password'}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				required
				disabled={disabled}
				autoFocus={autoFocus}
				minLength={minLength}
				autoComplete={autoComplete}
			/>
			<AuthPasswordToggle
				type="button"
				onClick={toggleVisibility}
				disabled={disabled}
				aria-label={isVisible ? hidePasswordLabel : showPasswordLabel}
				aria-pressed={isVisible}
			>
				{isVisible ? <EyeSlashIcon /> : <EyeIcon />}
			</AuthPasswordToggle>
		</AuthPasswordWrap>
	);
};

export default PasswordInput;
